/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import './AppOptions.css';

export default class AppOptions extends BaseCom {
    render() {
        return <div className="app-options">
            {this.props.children}
        </div>
    }
}